import Extend from 'flarum/common/extenders';
import Discussion from 'flarum/common/models/Discussion';
import DeterminationKeysPage from './components/DeterminationKeysPage';
export default [
// Discussion.determinationKeyFile() -> {url, fileName} or null, resolved
// server-side (see the `determinationKeyFile` field on DiscussionResource
// in extend.php).
new Extend.Model(Discussion).attribute('determinationKeyFile'), new Extend.Routes().add('keys', '/keys', DeterminationKeysPage)];